import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const Footer = () => {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    fullName: '',
    website: '',
    phone: '',
    email: '',
    description: '',
    hearAbout: ''
  })
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleRadioChange = (e) => {
    const { value } = e.target
    setFormData(prev => ({ ...prev, hearAbout: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!formData.email || !formData.description || !formData.hearAbout) {
      alert('Please fill in all required fields')
      return
    }

    setIsSubmitting(true)

    const formPayload = {
      access_key: '9b5cf56c-835b-46da-998b-5ed87cb32d11',
      name: formData.fullName,
      website: formData.website,
      phone: formData.phone,
      email: formData.email,
      message: formData.description,
      'How did you hear about us?': formData.hearAbout
    }

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formPayload)
      })

      if (response.ok) {
        navigate('/thank-you')
      }
    } catch (error) {
      alert('Something went wrong. Please try again.')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <footer id="contact">
      <div>
        <div className="s-60"></div>
        <div className="s-60"></div>
        <div className="container">
          <h2 className="title-intro c-white tc">BOOK AN APPOINTMENT</h2>
          <div className="s-50"></div>
          
          <form onSubmit={handleSubmit} style={{ maxWidth: '800px', margin: '0 auto' }}>
              <div className="row">
                <div className="col-lg-6 mb-4">
                  <input
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    value={formData.fullName}
                    onChange={handleChange}
                    style={{
                      width: '100%',
                      padding: '15px',
                      background: 'transparent',
                      border: '1px solid #ffffff',
                      color: '#ffffff',
                      fontSize: '16px'
                    }}
                  />
                </div>
                <div className="col-lg-6 mb-4">
                  <input
                    type="text"
                    name="website"
                    placeholder="Your website or company name"
                    value={formData.website}
                    onChange={handleChange}
                    style={{
                      width: '100%',
                      padding: '15px',
                      background: 'transparent',
                      border: '1px solid #ffffff',
                      color: '#ffffff',
                      fontSize: '16px'
                    }}
                  />
                </div>
                <div className="col-lg-6 mb-4">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone number"
                    value={formData.phone}
                    onChange={handleChange}
                    style={{
                      width: '100%',
                      padding: '15px',
                      background: 'transparent',
                      border: '1px solid #ffffff',
                      color: '#ffffff',
                      fontSize: '16px'
                    }}
                  />
                </div>
                <div className="col-lg-6 mb-4">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email *"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    style={{
                      width: '100%',
                      padding: '15px',
                      background: 'transparent',
                      border: '1px solid #ffffff',
                      color: '#ffffff',
                      fontSize: '16px'
                    }}
                  />
                </div>
                <div className="col-lg-12 mb-4">
                  <textarea
                    name="description"
                    placeholder="Briefly describe your request *"
                    value={formData.description}
                    onChange={handleChange}
                    required
                    rows="5"
                    style={{
                      width: '100%',
                      padding: '15px',
                      background: 'transparent',
                      border: '1px solid #ffffff',
                      color: '#ffffff',
                      fontSize: '16px',
                      resize: 'vertical'
                    }}
                  />
                </div>
                <div className="col-lg-12 mb-4">
                  <p className="c-white mb-3" style={{ fontSize: '16px' }}>How did you hear about us? *</p>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    {[
                      'Review Platforms (Clutch/G2/Gartner)',
                      'Referral (Friends/Colleagues)',
                      'Social Media (LinkedIn, Facebook)',
                      'Conference or Event',
                      'Blog or Article',
                      'Online Forums or Communities'
                    ].map((option) => (
                      <label key={option} style={{ display: 'flex', alignItems: 'center', color: '#ffffff', cursor: 'pointer' }}>
                        <input
                          type="radio"
                          name="hearAbout"
                          value={option}
                          checked={formData.hearAbout === option}
                          onChange={handleRadioChange}
                          style={{ marginRight: '10px', width: '20px', height: '20px', cursor: 'pointer' }}
                        />
                        <span style={{ fontSize: '16px' }}>{option}</span>
                      </label>
                    ))}
                  </div>
                </div>
                <div className="col-lg-12 tc">
                  <button 
                    type="submit" 
                    className="button"
                    disabled={isSubmitting}
                    style={{ minWidth: '300px', margin: '20px auto 0'}}
                  >
                    {isSubmitting ? 'Sending...' : 'Send'}
                  </button>
                </div>
              </div>
            </form>
        </div>
        <div className="s-100"></div>
      </div>
      <div className='bg-lite py-3'>
        <div className="container tc">
          <div className="s-20"></div>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
            <a href='#top' className='c-medium fw-400'>© 2026 - CrypCons. All rights reserved.</a>
            <span className='c-medium'>|</span>
            <a href='/cookie-policy' className='c-medium fw-400'>Cookie Policy</a>
            <span className='c-medium'>|</span>
            <a href='/privacy-policy' className='c-medium fw-400'>Privacy Policy</a>
          </div>
          <div className="s-20"></div>
        </div>
      </div>
    </footer>
  );
};

export { Footer }
